import FormatCurrency from 'components/Common/FormatCurrency'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Group from 'components/utils/Group'
import LineBagAltIcon from 'components/Luxkit/Icons/line/LineBagAltIcon'
import LineUsersAltIcon from 'components/Luxkit/Icons/line/LineUsersAltIcon'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import React, { useMemo } from 'react'
import { connect } from 'react-redux'
import ExperienceAppDiscountTag from '../ExperienceAppDiscountTag'
import LoyaltyPoints from 'loyalty/components/LoyaltyPoints'
import { IsEnabledLuxPlusDiscountedExperiences } from 'luxPlus/selectors/featureToggle'
import { getHasLuxPlusOrSubscriptionInCart } from 'checkout/selectors/view/luxPlusSubscription'

interface Props {
  transferTicket: App.ExperienceTransferOption;
  isLuxPlusEnabled: boolean;
}

function ExperienceTransferBookingOption(props: Props) {
  const { transferTicket, isLuxPlusEnabled = false } = props

  const hasMemberPrice = isLuxPlusEnabled && !!transferTicket.memberPrice

  const transferTicketrice = useMemo(() => {
    if (hasMemberPrice) {
      return transferTicket.memberPrice
    }
    return transferTicket.price
  }, [hasMemberPrice, transferTicket])

  return <VerticalSpacer gap={4}>
    <BodyText variant="large" weight="bold">{transferTicket.name}</BodyText>
    <BodyText variant="small">{transferTicket.description}</BodyText>
    <BodyText variant="small">
      <Group direction="horizontal" verticalAlign="center" gap={12}>
        <b>Max. capacity:</b>
        <Group direction="horizontal" verticalAlign="center" gap={4} as="span">
          <LineUsersAltIcon size="XS" /> {transferTicket.maxPassengers}
        </Group>
        <Group direction="horizontal" verticalAlign="center" gap={4} as="span">
          <LineBagAltIcon size="XS" /> {transferTicket.maxCheckedBags}
        </Group>
      </Group>
    </BodyText>
    <Group direction="horizontal" horizontalAlign="space-between">
      <Heading variant="heading5" colour={hasMemberPrice ? 'lux-plus' : 'neutral-one'}>
        <FormatCurrency value={transferTicketrice} />
      </Heading>
    </Group>
    <LoyaltyPoints
      calculationRequests={{
        price: transferTicket.price,
        memberPrice: isLuxPlusEnabled ? transferTicket.memberPrice : 0,
        loyaltyProductType: 'experience',
      }}
      calculationType="exact"
      hideStatusCredits
    />
    <ExperienceAppDiscountTag discountPercentage={transferTicket.discounts?.app.percentage} />
  </VerticalSpacer>
}

const mapStateToProps = (state: App.State) => {
  return {
    isLuxPlusEnabled: IsEnabledLuxPlusDiscountedExperiences(state) && getHasLuxPlusOrSubscriptionInCart(state),
  }
}

export default connect(mapStateToProps)(ExperienceTransferBookingOption)
